export enum OneMealServiceStatus {
    PENDING = 'PENDING',
    COOK_ALLOCATED = 'COOK_ALLOCATED',
    COOK_CONFIRMED = 'COOK_CONFIRMED',
    ONGOING = 'ONGOING',
    CANCELLED = 'CANCELLED',
    FULFILLED = 'FULFILLED',
    RESCHEDULED = 'RESCHEDULED'
}